import axios from "axios";
import { generateErrorMsg, getServerUrl } from "utils/commonTools";
import { AnnouncementData } from "../types/AnnoucementData";

export const useAnnouncement = () => {
  const getAnnouncements = async (): Promise<{
    succeeded: boolean;
    msg: string;
    data: AnnouncementData[];
  }> => {
    const config = {
      headers: { "Content-type": "application/json" },
    };
    try {
      const { data } = await axios.get<AnnouncementData[]>(
        getServerUrl() + "announcements",
        config
      );
      return { succeeded: true, msg: "", data };
    } catch (error) {
      var errMsg = generateErrorMsg(error);
      return { succeeded: false, msg: `お知らせの取得に失敗しました。${errMsg}`, data: [] };
    }
  };

  return { getAnnouncements };
};
